import { tradingSummary } from '@/utils/tradingSummary';
import CountUp from '@/components/base/CountUp';
import Reveal from '@/components/base/Reveal';

const metrics = [
  { value: tradingSummary.totalTrades, decimals: 0, suffix: '', label: 'Total Trades' },
  { value: tradingSummary.winTrades, decimals: 0, suffix: '', label: 'Winning Trades' },
  { value: tradingSummary.lossTrades, decimals: 0, suffix: '', label: 'Losing Trades' },
  { value: tradingSummary.winRateValue, decimals: 1, suffix: '%', label: 'Win Rate' },
];

function ProcessNumbers() {
  return (
    <section
      id="process-numbers"
      className="w-full bg-background-100 border-y border-background-200 px-4 md:px-8 lg:px-12 py-16 md:py-24"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[42px] lg:text-[48px]">
            The Process In Numbers
          </h2>
          <p className="mt-4 text-[15px] text-foreground-600 max-w-[560px]">
            A record of how the process actually played out across the trading period.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {metrics.map((m, idx) => (
            <Reveal key={m.label} delay={idx * 90}>
              <div
                className={`rounded-lg border px-5 md:px-6 py-6 h-full hover:-translate-y-1 transition-transform duration-300 ${
                  idx === 0
                    ? 'border-accent-300 bg-accent-100/60'
                    : 'border-background-300 bg-background-50'
                }`}
              >
                <p
                  className={`font-data text-[34px] md:text-[42px] font-semibold leading-none ${
                    idx === 0 ? 'text-primary-700' : 'text-foreground-950'
                  }`}
                >
                  <CountUp value={m.value} decimals={m.decimals} suffix={m.suffix} />
                </p>
                <p className="mt-3 text-[12px] text-foreground-500">{m.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={140}>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] font-data tracking-wider text-foreground-500">
            <span>
              Trading period:{' '}
              <span className="text-foreground-800">{tradingSummary.period}</span>
            </span>
            <span className="hidden sm:inline text-background-400">|</span>
            <span>
              Instrument: <span className="text-foreground-800">{tradingSummary.instrument}</span>
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default ProcessNumbers;